<template>
  <div class="project-card"
       v-lazy:background-image="project.backgroundImage">
    <div class="title">
      <h3>{{ project.title }}</h3>
      <p>{{ project.subtitle }}</p>
      <button v-on:click="goTo(project.url)">Ver projeto</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectCard',
  data: function () {
    return {
      project: {}
    }
  },
  props: {
    projectData: Object
  },
  created: function () {
    this.project = this.$props.projectData
  },
  methods: {
    goTo: function (pageUrl) {
      this.$router.push('projeto/' + pageUrl)
    }
  }
}
</script>

<style scoped lang="scss">
  .project-card {
    background-color: #fff;
    height: 300px;
    background-size: cover;
    background-position: center;
    border-radius: 10px;
    box-sizing: border-box;
    position: relative;
    transition: all 0.4s;
    overflow: hidden;

    .title {
      background-color: rgba(255, 255, 255, 0.95);
      position: absolute;
      left: 0;
      right: 0;
      bottom: -100%;
      text-align: center;
      transition: all 300ms ease-out;
      padding: 20px 10px;
      border-radius: 10px 10px 0 0;

      h3 {
        color: #000;
        margin: 0 0 10px;
        text-transform: uppercase;
        font-weight: 500;
        font-size: 1rem;
      }

      p {
        color: #000;
        margin: 0 0 10px;
        font-weight: 300;
      }

      button {
        cursor: pointer;
        outline: none;
        background-color: #3d337f;
        color: #fff;
        border: none;
        border-radius: 5px;
        font-family: Montserrat, sans-serif;
        text-transform: uppercase;
        font-weight: 500;
        padding: 5px 10px;
        transition: all 0.3s;

        &:hover {
          background-color: #573ac7;
          color: #fff;
        }
      }
    }

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);

      .title {
        bottom: 0;
      }
    }
  }
</style>
